import React from 'react';
import EstadoCorreo from './EstadoCorreo';
import { sanitizarMensaje } from './sanitizarMensaje';
import { fechaHoraCorta } from './fechas';

// Misma lectura que el chat original: "Nombre - Organización" en negrita
// (o "YO - Organización" en el propio), texto, fecha abajo a la derecha y,
// solo en el propio, la línea de estado del correo.
export default function Burbuja({ mensaje, propio, fecha, reenviando, onReenviar }) {
  const cabecera = propio ? 'YO - ' + mensaje.nombreEntidadProveedor : mensaje.nombreUsuario + ' - ' + mensaje.nombreEntidadProveedor;
  return (
    <div className={'chat-burbuja ' + (propio ? 'chat-burbuja-propia' : 'chat-burbuja-ajena')}>
      <b className="chat-burbuja-quien">{cabecera}</b>
      <div className="chat-burbuja-texto">{sanitizarMensaje(mensaje.mensaje)}</div>
      <div className="chat-burbuja-fecha">{fechaHoraCorta(fecha) || mensaje.fecha || ''}</div>
      {propio && <EstadoCorreo mensaje={mensaje} reenviando={reenviando} onReenviar={onReenviar} />}
    </div>
  );
}
